<mat-card appearance="outlined" class="d-flex flex-column">
  <mat-card-header>
    <mat-card-title>
      <h4>{{title}}</h4>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="d-flex flex-column flex-grow-1">
    <div class="d-flex flex-row align-items-center"
      style="height: 70px">
      <div class="well my-drop-zone mb-2"
        ng2FileDrop
        [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
        (fileOver)="fileOverBase($event)"
        [uploader]="uploader"
        (onFileDrop)="onFileDrop()">
        <div class="d-flex align-items-center justify-content-center drop-zone-info text-muted">
          <mat-icon>attachment</mat-icon><span>{{ 'fileUpload.dropFileHere' | translate }}</span>
        </div>
      </div>
    </div>
    <div>
      <input type="file"
        #file
        ng2FileSelect
        [uploader]="uploader" />
      </div>
    </mat-card-content>
    <mat-card-footer class="d-flex flex-wrap align-items-start justify-content-start m-2 upload-footer">
      <div class="d-flex align-items-center mt-2">
        @if (uploader?.queue?.length > 0) {
          <div class="mr-2"
            >
            @if (uploader?.queue?.length > 2) {
              <span>{{uploader?.queue?.length}}-Name:</span>
            }
            <span>{{uploader.queue[0].file.name}}</span>
          </div>
        }
        <div>
          <button mat-raised-button
            (click)="uploader.uploadAll()"
            [disabled]="!uploader.getNotUploadedItems().length">
            <mat-icon>cloud_upload</mat-icon> {{ 'fileUpload.uploadFile' | translate }}
          </button>
        </div>
      </div>
    </mat-card-footer>
  </mat-card>